module.exports = __webpack_public_path__ + "img/model_52_zh.88fb6932.jpg";